import { AbandonRedirectComponent } from './ocmuser/abandon-redirect/abandon-redirect.component';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { OneColumnLayoutComponent } from './layouts/one-column-layout/one-column-layout.component';
import { PageConfig } from 'config/page.config';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
import { InvalidPermissionsComponent } from './invalid-permissions/invalid-permissions.component';
import { ProductDetailComponent } from './ocmuser/product/product-detail.component';
import { LandingPageComponent } from './ocmuser/landing/landing-page.component';
import { BillingPageComponent } from './ocmuser/billing/billing-page.component';
import { ManageLicensesComponent } from './ocmadmin/licenses/manage-licenses.component';
import { ManageAdminsComponent } from './ocmadmin/admins/manage-admins.component';
import { authGuard } from './users/authGuard';
import { OrderReviewComponent } from './ocmuser/review/order-review.component';
import { OrderConfirmationComponent } from './ocmuser/confirmation/order-confirmation.component';
import { nonAuthGuard } from './users/non-authGuard';
import { RenewSubscriptionsComponent } from './ocmuser/renew/renew-page.component';
import { AdminCallbackComponent } from './ocmadmin/admins/admin-callback/admin-callback.component';

export const routes: Routes = [
  
  {
    path: PageConfig.paths.landingPage,
    canActivate: [nonAuthGuard],
    component: OneColumnLayoutComponent,
    children: [
      {
        path: '',
        component: LandingPageComponent
      }
    ]
  },
  {
     path: PageConfig.paths.ocm.abandonCallback,
     canActivate: [authGuard],
     component: AbandonRedirectComponent
  },
  {
    path: PageConfig.paths.invalidPermissions,
    pathMatch: 'full',
    component: OneColumnLayoutComponent,
    children: [
      {
        path: '**',
        component: InvalidPermissionsComponent
      }
    ]
  },
  {
    path: PageConfig.paths.ocm.product,
    canActivate: [nonAuthGuard],
    pathMatch: 'full',
    component: OneColumnLayoutComponent,
    children: [
      {
        path: '**',
        component: ProductDetailComponent
      }
    ]
  },
  {
    path: PageConfig.paths.ocm.billing,
    canActivate: [authGuard],
    pathMatch: 'full',
    component: OneColumnLayoutComponent,
    children: [
      {
        path: '**',
        component: BillingPageComponent
      }
    ]
  }, 
  {
    path: PageConfig.paths.ocm.review,
    canActivate: [authGuard],
    pathMatch: 'full',
    component: OneColumnLayoutComponent,
    children: [
      {
        path: '**',
        component: OrderReviewComponent
      }
    ]
  }, 
  {
    path: PageConfig.paths.ocm.confirmation,
    canActivate: [authGuard],
    pathMatch: 'full',
    component: OneColumnLayoutComponent,
    children: [
      {
        path: '**',
        component: OrderConfirmationComponent
      }
    ]
  },
  {
    path: PageConfig.paths.ocm.renew,
    canActivate: [authGuard],
    pathMatch: 'full',
    component: OneColumnLayoutComponent,
    children: [
      {
        path: '**',
        component: RenewSubscriptionsComponent
      }
    ]
  },  
  {
    path: PageConfig.paths.ocm.licenses,
    canActivate: [authGuard],
    pathMatch: 'full',
    component: OneColumnLayoutComponent,
    children: [
      {
        path: '**',
        component: ManageLicensesComponent
      }
    ]
  },
  {
    path: PageConfig.paths.ocm.admins,
    canActivate: [authGuard],
    pathMatch: 'full',
    component: OneColumnLayoutComponent,
    children: [
      {
        path: '**',
        component: ManageAdminsComponent
      }
    ]
  }, 
  {
    path: PageConfig.paths.ocm.adminCallback,
    canActivate: [authGuard],
    pathMatch: 'full',
    component: OneColumnLayoutComponent,
    children: [
      {
        path: '**',
        component: AdminCallbackComponent
      }
    ]
  },
  {
    path: PageConfig.paths.login,
    canActivate: [authGuard],
    children : []
  },
  {
    path: PageConfig.paths.callback,
    canActivate: [authGuard],
    children : []
  },
  {
    path: '**',
    component: OneColumnLayoutComponent,
    children: [
      {
        path: '**',
        component: PageNotFoundComponent
      }
    ]
  },
  
];

@NgModule({
  imports: [
    RouterModule.forRoot(
      routes
    ),
  ],
  exports: [
    RouterModule
  ],
})
export class AppRoutingModule {
}
